
namespace SP {
    export interface StockingLotInfo {
        id: string;
        createUser: string;
        arrivalId: string;
        arrivalDate: string;
        arrivalDateRaw: string;
        item: ItemInfo;
        itemRefillRequired: boolean;
        itemReservedQuantity: number;
        itemReservedToCountries: string;
        stockId: string;
        stockPlacementId: number;
        stockPlacementName: string;
        stockPlacementData: string;
        stockPlacementLocationKey: string;
        initialQuantity: number;
        placementQuantity: number;
        placementQuantityItemAllLots: number;
        availableQuantity: number;
        productionDate: string;
        expirationDate: string;
        expirationDateRaw: string;
        timestamp: string;
        batchNumber: string;
        purchaseOrderLineId: string;
        isReturn: boolean;
        quarantine: boolean;
    }


    export interface ItemRefillInfo {
        item: ItemInfo;
        itemRefillRequired: boolean;
        itemReservedQuantity: number;
        itemReservedToCountries: string;
        placements: ItemRefillLotInfo[];
    }

    export interface ItemRefillLotInfo {
        placementId: number;
        placementData: string;
        totalQty: number;
    }
}